import { createDocument, getDocuments, updateDocument } from '../services/documents';

const createChargingProfile = async (charging_profile: any) => {
  const data = await createDocument(charging_profile, 'charging_profiles');
  return data;
};

const updateChargingProfile = async (charging_profile: any, id: any) => {
  const data = await updateDocument(id, charging_profile, 'charging_profiles');
  return data;
};

const getChargingProfiles = async () => {
  const data = await getDocuments('charging_profiles');
  return data;
};

const getChargingProfileDetail = async (id) => {
  const data = await getDocuments(`charging_profiles/${id}`);
  return data;
};

export { createChargingProfile, updateChargingProfile, getChargingProfiles, getChargingProfileDetail };
